var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReactionAngry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M15.897 31.794C7.117 31.794 0 24.677 0 15.897 0 7.117 7.117 0 15.897 0c8.78 0 15.898 7.117 15.898 15.897 0 8.78-7.118 15.897-15.898 15.897z",
    transform: "translate(-371 -1271) translate(39 1271) translate(332)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3742",
    d: "M11.484 20.009c-2.657-.13.62-3.665 1.33-4.38 1.922-1.943 4.517-3.318 7.31-2.68 1.958.446 3.675 1.606 5.001 3.091.512.573 1.305 1.497 1.31 2.317.003.437-.513 1.335-.99 1.466-.942.26-1.046-.648-1.41-1.359-.926-1.815-2.15-3.542-4.238-4.064-2.374-.543-4.322.964-5.596 2.823-.492.717-.738 1.923-1.493 2.48-.298.22-.774.328-1.224.306M14.299 10.662c0 1.057-1.079 1.914-2.408 1.914-1.33 0-2.408-.857-2.408-1.914s1.078-1.914 2.408-1.914c1.33 0 2.408.857 2.408 1.914",
    transform: "translate(-371 -1271) translate(39 1271) translate(332)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3742",
    d: "M14.299 10.662s.493-1.79-1.729-3.272c-2.222-1.482-4.94-1.729-4.446-.988.494.74 2.84 1.358 3.088 2.47M19.917 10.662c0 1.057 1.078 1.914 2.408 1.914 1.33 0 2.408-.857 2.408-1.914s-1.078-1.914-2.408-1.914c-1.33 0-2.408.857-2.408 1.914",
    transform: "translate(-371 -1271) translate(39 1271) translate(332)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2E3742",
    d: "M19.917 10.662s-.494-1.79 1.728-3.272c2.224-1.482 4.94-1.729 4.446-.988-.494.74-2.84 1.358-3.087 2.47",
    transform: "translate(-371 -1271) translate(39 1271) translate(332)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactionAngry);
export default __webpack_public_path__ + "static/media/reactionAngry.b7bbf8bd.svg";
export { ForwardRef as ReactComponent };